const __NODE_BASE_URL__ = "https://pa.algorit.im";

const __NODE_API_URL__ = `${__NODE_BASE_URL__}/v1/`;

export { __NODE_BASE_URL__, __NODE_API_URL__ };
